import request from '../../../../../services/axios';

export const postWithdrawRequest = async (credit_guid: string) => {
  const {data} = await request.post(
    '/api/v2/payment/cashback/withdraw-request',
    {credit_guid},
  );

  return data;
};
